import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectFilterLoader, selectInputControls } from 'redux/reports';
import { currentUser } from 'redux/session/selectors';
import { ReportingSelectionForm } from '..';
import NoDataDisplay from '../noDataDisplay';

export const ReportPanel: React.FC<{}> = () => {
  const filterLoader: boolean = useSelector(selectFilterLoader);
  const inputControls: [] = useSelector(selectInputControls);
  const user: any = useSelector(currentUser);
  const reportContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const reportDom = reportContainerRef?.current;
    if (reportDom) {
      reportDom.innerHTML = '';
    }
  }, [user]);

  useEffect(() => {
    const reportDom = reportContainerRef?.current;
    if (reportDom && filterLoader) {
      reportDom.innerHTML = '';
    }
  }, [filterLoader]);

  return (
    <div className="report--wrapper">
      <div className="report--control-panel">
        <ReportingSelectionForm />
      </div>
      <div className="report--body">
        {inputControls ? (
          <div
            id="reportContainer"
            ref={reportContainerRef}
            className="report--body-content"
            data-testid="reportContainer"
          >
            {/* DYNAMIC REPORT CONTENT AREA */}
          </div>
        ) : (
          <NoDataDisplay />
        )}
      </div>
    </div>
  );
};

export default React.memo(ReportPanel);
